import type { CurrenciesDictionary, Settings } from '@velasca/types'

interface FormattedCurrency {
  code: string
  label: string
  symbol: string
  flag: string
}

/**
 * It takes an object of currencies and returns an array of formatted currencies.
 *
 * @param currenciesDictionary - A dictionary of currencies classified by their languageCode.
 * @param languageCode - The short-code that identifies the language of the currency.
 */
export const formatCurrencies = (
  currenciesDictionary: CurrenciesDictionary,
  languageCode: Settings['language'] = 'it',
): FormattedCurrency[] => {
  const formattedCurrencies = []

  for (const [currency, currencyProperties] of Object.entries(
    currenciesDictionary,
  )) {
    const uppercaseLanguageCode = languageCode.toUpperCase()
    const formattedCurrency = {
      code: currencyProperties.code,
      label: currencyProperties.label[uppercaseLanguageCode],
      symbol: currencyProperties.symbol,
      flag: currencyProperties.flag,
    }

    currency !== '' && formattedCurrencies.push(formattedCurrency)
  }
  formattedCurrencies.sort((a, b) => (a.label < b.label ? -1 : 1))

  return formattedCurrencies
}
